module.exports = __webpack_public_path__ + "img/fair.36a6ad99.svg";